import Image from "next/image";

import LogoImpact120 from "./LogoImpact120.png";

export const NumeriqueResponsableLabel = () => {
  return (
    <a
      href="https://www.impactfrance.eco/nos-actus/impact-40-120-2025-decouvrez-les-laureats-2025"
      aria-label="Impact 40/120 award"
      className="relative w-18 h-[86px]"
    >
      <Image
        src={LogoImpact120}
        alt="Label 120"
        layout="fill"
        objectFit="contain"
        objectPosition="top"
        sizes="72px"
      />
    </a>
  );
};
